// extracted by mini-css-extract-plugin
export default {"modalDMVSpecialCharBody":"DMVSpecialCharModal_modalDMVSpecialCharBody__wW96J"};